






































































































































































































































import { Component, Watch, Vue } from "vue-property-decorator";
import axios, { AxiosRequestConfig } from "axios";
import api from "../../api/index";
import Box from "../components/Box.vue";
import Lists from "../components/Lists.vue";
import { Action, Getter } from "vuex-class";
import AccessInvitationModal from "../components/AccessInvitationModal.vue";
import UserProfileModal from "../components/UserProfileModal.vue";
import {perPageOptions} from '@/constants/ListOptions'

const moment = require("moment");

@Component({
	components: {
		Box,
		AccessInvitationModal,
		UserProfileModal,
	},
})
export default class UserProfile extends Lists {
  @Getter("user") currentUser: any;
	currentAccessId = null;

	user = {
		first_name: "",
		last_name: "",
		mobile_phone_number: null,
		email: "",
		gender: null,
	};

  perPageOptions = perPageOptions

	accesses = [];
	accessWordSearched = "";
	accessesTotalPages = 0;
	accessesCurrentPage = 1;
	accessesPerPage: number = Number(localStorage.getItem('resultsPerListPage')) || this.perPageOptions[0];
	accessesSortField = "";
	accessesSortOrder = false;

	accessesCodes = [];
	accessesCodesTotalPages = 0;
	accessesCodesCurrentPage = 1;
	accessesCodesPerPage: number = Number(localStorage.getItem('resultsPerListPage')) || this.perPageOptions[0];
	accessesCodesSortField = "";
	accessesCodesSortOrder = false;
	accessesCodesTotalResults = 0;

	openings = []
  openingsTotalPages = 0
  openingsCurrentPage = 1
  openingsPerPage: number = Number(localStorage.getItem('resultsPerListPage')) || this.perPageOptions[0]
  openingsTotalResults = 0

	loading = false;
	userLoading = false;
	isUserProfileModalActive = false;

	isAccessInvitationModalActive = false;

	get currentAccess() {
		var result = this.accesses.filter((obj: any) => {
			return obj.id === this.currentAccessId;
		});
		return result[0];
	}

	async sendAccessInvitation(invitation: any) {
		try {
			const res = await api.post(
				"bo/accesses/" + this.currentAccessId + "/invitations",
				{ invitation }
			);
			this.getUserAccesses();
			this.$toast.open({
				message: "L'invitation a bien été envoyée",
				type: "is-novaccess-purple",
				duration: 2000,
			});
		} catch (e) {
			if (e.response.status === 201) {
				console.log(e.response.status);
			}
		}
	}

	@Getter("admin") admin: any;

	async mounted() {
		await api.setToken();
		await this.getUser();
		await this.getUserAccesses();
		if (this.admin) {
			await this.getUserAccessesCodes();
		}
    if (this.currentUser.can_view_openings || this.admin) {
      await this.getUserOpenings();
    }
		this.addUserNameInBreadcrumb();
	}

	async getUser() {
		try {
			const res = await api.get("bo/users/" + this.$route.params.userId);
			this.user = res.data;
		} catch (e) {
			if (e.response.status === 401) {
				console.log(e.response.status);
			}
		}
	}

	async changePermission(key, value) {
		try {
			const res = await api.put("bo/users/" + this.$route.params.userId, {
				user: {
					[key]: value,
				},
			});
			this.user = res.data;
		} catch (e) {
			if (e.response.status === 401) {
				console.log(e.response.status);
			}
		}
	}

	@Watch("accessesPerPage")
  @Watch("accessWordSearched")
  onSearchPropsChanged(val: any, old: any) {
    if (old && val && val.toString() === old.toString()) {
      return
    }
    localStorage.setItem('resultsPerListPage', this.accessesPerPage.toString())
    this.getUserAccesses();
  }

	async onSortAccesses(field: any, order: any) {
		this.accessesSortField = field;
		order === "asc"
			? (this.accessesSortOrder = false)
			: (this.accessesSortOrder = true);
		this.getUserAccesses();
	}

  async onSortAccessesCodes(field: any, order: any) {
		this.accessesCodesSortField = field;
		order === "asc"
			? (this.accessesCodesSortOrder = false)
			: (this.accessesCodesSortOrder = true);
		this.getUserAccessesCodes();
	}

  @Watch("accessesCodesPerPage")
  onAccessesCodesPerPage() {
    localStorage.setItem('resultsPerListPage', this.accessesCodesPerPage.toString())
    this.getUserAccessesCodes()
  }

	async getUserAccessesCodes(pageNumber?: number) {
		try {
			const res = await api.get(
				"bo/users/" + this.$route.params.userId + "/access_codes",
				{
					params: {
						page: pageNumber,
						per_page: this.accessesCodesPerPage,
						order: this.accessesCodesSortField,
						order_desc: this.accessesCodesSortOrder,
					},
				}	
			);
			this.accessesCodesTotalPages = parseInt(res.headers["x-pagination-total-pages"]);
			this.accessesCodesCurrentPage = parseInt(res.headers["x-pagination-page"]);
			this.accessesCodesTotalResults = parseInt(res.headers["x-pagination-total"]);

			this.accessesCodes = res.data;
		} catch (e) {
			if (e.response.status === 401) {
				console.log(e.response.status);
			}
		}
	}

	async getUserAccesses(pageNumber?: number) {
		try {
			const res = await api.get(
				"bo/users/" + this.$route.params.userId + "/groups",
				{
					params: {
						page: pageNumber,
						per_page: this.accessesPerPage,
						keywords: this.accessWordSearched,
						order: this.accessesSortField,
						order_desc: this.accessesSortOrder,
					},
				}	
			);
			this.accessesTotalPages = parseInt(
				res.headers["x-pagination-total-pages"]
			);
			this.accessesCurrentPage = parseInt(res.headers["x-pagination-page"]);
			this.accessesPerPage = parseInt(res.headers["x-pagination-per-page"]);
			this.accessesTotalResults = parseInt(res.headers["x-pagination-total"]);

			this.accesses = res.data;
		} catch (e) {
			if (e.response.status === 401) {
				console.log(e.response.status);
			}
		}
	}

  @Watch("openingsPerPage")
  onOpeningsPerPage() {
    localStorage.setItem('resultsPerListPage', this.openingsPerPage.toString())
    this.getUserOpenings()
  }

  async exportOpenings() {
    try {
      const res = await api.get(
        `bo/users/${this.$route.params.userId}/openings.csv`,
        {
          headers: {
            'Content-Type': 'text/csv'
          },
          data: {}
        }
      )
      this.$toast.open({
        message: "Vous allez recevoir le compte-rendu d'horodatage sur votre adresse email.",
        type: "is-novaccess-purple",
        duration: 2000,
      });
    } catch (e) {
      this.$toast.open({
        message: "Une erreur est survenue dans l'export du compte-rendu d'horodatage",
        type: "is-danger",
        duration: 2000,
      });
    }
  }

  async getUserOpenings(pageNumber?: number) {
    try {
      const res = await api.get(
        `bo/users/${this.$route.params.userId}/openings`,
        {
          params: {
            page: pageNumber,
            per_page: this.openingsPerPage
          }
        }
      );
      this.openingsTotalPages = parseInt(res.headers["x-pagination-total-pages"]);
      this.openingsCurrentPage = parseInt(res.headers["x-pagination-page"]);
      this.openingsTotalResults = parseInt(res.headers["x-pagination-total"]);

      this.openings = res.data;
    } catch (e) {
      if (e.response.status === 401) {
        console.log(e.response.status);
      }
    }
  }

	async suspendUser(userId: any) {
		try {
			const res = await api.post("bo/users/" + userId + "/suspension", {});
			await this.getUser();
		} catch (e) {
			if (e.response.status !== 201) {
				console.log(e.response.status);
			}
		}
	}
	async reactivateUser(userId: any) {
		try {
			const res = await api.delete("bo/users/" + userId + "/suspension");
			await this.getUser();
		} catch (e) {
			if (e.response.status !== 200) {
				console.log(e.response.status);
			}
		}
	}

	addUserNameInBreadcrumb() {
		if (!this.user.first_name || !this.user.last_name) {
			return;
		} else {
			var firstName = this.user.first_name.toLowerCase();
			firstName = firstName.charAt(0).toUpperCase() + firstName.slice(1);
			var lastName = this.user.last_name.toLowerCase();
			lastName = lastName.charAt(0).toUpperCase() + lastName.slice(1);

			const crumb: any = document.querySelector(".breadcrumb .is-current");
			if (crumb) {
				crumb.innerHTML = `${firstName} ${lastName}`;
			}
		}
	}

  async removeUser(userId, groupId) {
    try {
      await api.delete(`bo/groups/${groupId}/memberships/${userId}`)
      this.getUserAccesses()
      this.$toast.open({
        message: "Le groupe a bien été dissocié",
        type: "is-novaccess-purple",
        duration: 2000,
      });
    } catch (error) {
      console.log(error)
    }
  }

  copy(url: string) {
    navigator.clipboard.writeText(url)
    this.$toast.open({
      message: "Copié !",
      type: "is-novaccess-purple",
      duration: 1000,
    });
  }
}
